import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// customers — ลูกค้า (sales-owned split from accounting_partners)
// ============================================================================
export const customers = sqliteTable("sales_customers", {
  id: text("id").primaryKey(), // ULID; preserved from accounting_partners during backfill
  companyId: text("company_id").notNull(),
  partnerCode: text("partner_code"),
  partnerName: text("partner_name").notNull(),
  isCustomer: integer("is_customer").notNull().default(1),
  isSupplier: integer("is_supplier").notNull().default(0),
  partnerEntityType: text("partner_entity_type", {
    enum: ["individual", "company"],
  }).notNull(),
  taxId: text("tax_id"),
  idCardNumber: text("id_card_number"),
  phone: text("phone"),
  email: text("email"),
  address: text("address"),
  notes: text("notes"),
  lineId: text("line_id"),
  creditLimit: real("credit_limit").default(0),
  paymentTermDays: integer("payment_term_days").default(30),
  bankAccountNo: text("bank_account_no"),
  bankCode: text("bank_code"),
  bankBranch: text("bank_branch"),
  province: text("province"),
  district: text("district"),
  zipCode: text("zip_code"),
  contactPerson: text("contact_person"),
  branchNo: text("branch_no"),
  defaultAccountId: text("default_account_id"),
  defaultPriceListId: text("default_price_list_id"),
  customData: text("custom_data"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyIdx: index("sales_customer_company_idx").on(table.companyId),
  companyCustomerIdx: index("sales_customer_company_customer_idx").on(table.companyId, table.isCustomer),
  companyDeletedIdx: index("sales_customer_company_deleted_idx").on(table.companyId, table.deletedAt),
}));

export type Customer = typeof customers.$inferSelect;
export type NewCustomer = typeof customers.$inferInsert;
export const salesCustomers = customers;
export type SalesCustomer = Customer;
export type NewSalesCustomer = NewCustomer;
